export const validation = {
  userType: 'User type is required',
  provider: 'is required',
  message: 'Message is required',
};
